// generalSettings reducer

import {
  GET_VAT_PERIOD_LIST,
  GET_VAT_PERIOD_LIST_SUCCESS,
  GET_VAT_PERIOD_LIST_FAILURE,
  GET_VAT_PERIOD_DETAILS,
  GET_VAT_PERIOD_DETAILS_SUCCESS,
  GET_VAT_PERIOD_DETAILS_FAILURE,
  ADD_VAT_PERIOD,
  ADD_VAT_PERIOD_SUCCESS,
  ADD_VAT_PERIOD_FAILURE,
  UPDATE_VAT_PERIOD,
  UPDATE_VAT_PERIOD_SUCCESS,
  UPDATE_VAT_PERIOD_FAILURE,
  DELETE_VAT_PERIOD,
  DELETE_VAT_PERIOD_SUCCESS,
  DELETE_VAT_PERIOD_FAILURE,
  GET_RENEWAL_FREQUENCIES_LIST,
  GET_RENEWAL_FREQUENCIES_LIST_SUCCESS,
  GET_RENEWAL_FREQUENCIES_LIST_FAILURE,
  GET_RENEWAL_FREQUENCIES_DETAILS,
  GET_RENEWAL_FREQUENCIES_DETAILS_SUCCESS,
  GET_RENEWAL_FREQUENCIES_DETAILS_FAILURE,
  ADD_RENEWAL_FREQUENCIES,
  ADD_RENEWAL_FREQUENCIES_SUCCESS,
  ADD_RENEWAL_FREQUENCIES_FAILURE,
  UPDATE_RENEWAL_FREQUENCIES,
  UPDATE_RENEWAL_FREQUENCIES_SUCCESS,
  UPDATE_RENEWAL_FREQUENCIES_FAILURE,
  DELETE_RENEWAL_FREQUENCIES,
  DELETE_RENEWAL_FREQUENCIES_SUCCESS,
  DELETE_RENEWAL_FREQUENCIES_FAILURE,
  GET_UNIT_FREQUENCIES_LIST,
  GET_UNIT_FREQUENCIES_LIST_SUCCESS,
  GET_UNIT_FREQUENCIES_LIST_FAILURE,
  GET_UNIT_FREQUENCIES_DETAILS,
  GET_UNIT_FREQUENCIES_DETAILS_SUCCESS,
  GET_UNIT_FREQUENCIES_DETAILS_FAILURE,
  ADD_UNIT_FREQUENCIES,
  ADD_UNIT_FREQUENCIES_SUCCESS,
  ADD_UNIT_FREQUENCIES_FAILURE,
  UPDATE_UNIT_FREQUENCIES,
  UPDATE_UNIT_FREQUENCIES_SUCCESS,
  UPDATE_UNIT_FREQUENCIES_FAILURE,
  DELETE_UNIT_FREQUENCIES,
  DELETE_UNIT_FREQUENCIES_SUCCESS,
  DELETE_UNIT_FREQUENCIES_FAILURE,
  GET_MASTER_TIME_FRAME_LIST,
  GET_MASTER_TIME_FRAME_LIST_SUCCESS,
  GET_MASTER_TIME_FRAME_LIST_FAILURE,
  GET_MASTER_TIME_FRAME_DETAILS,
  GET_MASTER_TIME_FRAME_DETAILS_SUCCESS,
  GET_MASTER_TIME_FRAME_DETAILS_FAILURE,
  ADD_MASTER_TIME_FRAME,
  ADD_MASTER_TIME_FRAME_SUCCESS,
  ADD_MASTER_TIME_FRAME_FAILURE,
  UPDATE_MASTER_TIME_FRAME,
  UPDATE_MASTER_TIME_FRAME_SUCCESS,
  UPDATE_MASTER_TIME_FRAME_FAILURE,
  DELETE_MASTER_TIME_FRAME,
  DELETE_MASTER_TIME_FRAME_SUCCESS,
  DELETE_MASTER_TIME_FRAME_FAILURE,
  GET_LOCAL_SETTINGS_MASTER_CONFIG_LIST,
  GET_LOCAL_SETTINGS_MASTER_CONFIG_LIST_SUCCESS,
  GET_LOCAL_SETTINGS_MASTER_CONFIG_LIST_FAILURE,
  GET_CONFIG_ITEMS_COMPANY_EDITABLE_LIST,
  GET_CONFIG_ITEMS_COMPANY_EDITABLE_LIST_SUCCESS,
  GET_CONFIG_ITEMS_COMPANY_EDITABLE_LIST_FAILURE,
  UPDATE_LOCAL_SETTINGS_MASTER_CONFIG_TOGGLE,
  UPDATE_LOCAL_SETTINGS_MASTER_CONFIG_TOGGLE_SUCCESS,
  UPDATE_LOCAL_SETTINGS_MASTER_CONFIG_TOGGLE_FAILURE,
  GET_LOCAL_SETTINGS_MASTER_CONFIG_USER_LIST,
  GET_LOCAL_SETTINGS_MASTER_CONFIG_USER_LIST_SUCCESS,
  GET_LOCAL_SETTINGS_MASTER_CONFIG_USER_LIST_FAILURE,
  UPDATE_LOCAL_SETTINGS_MASTER_CONFIG_USER,
  UPDATE_LOCAL_SETTINGS_MASTER_CONFIG_USER_SUCCESS,
  UPDATE_LOCAL_SETTINGS_MASTER_CONFIG_USER_FAILURE,
} from "./actionType";

const initialState = {
  vatPeriodList: [],
  vatPeriodListError: [],
  vatPeriodListLoading: false,

  vatPeriodDetails: [],
  vatPeriodDetailsError: [],
  vatPeriodDetailsLoading: false,

  addVatPeriodSuccess: [],
  addVatPeriodError: [],
  addVatPeriodLoading: false,

  updateVatPeriodSuccess: [],
  updateVatPeriodError: [],
  updateVatPeriodLoading: false,

  deleteVatPeriodSuccess: [],
  deleteVatPeriodError: [],
  deleteVatPeriodLoading: false,

  renewalFrequenciesList: [],
  renewalFrequenciesListError: [],
  renewalFrequenciesListLoading: false,

  renewalFrequenciesDetails: [],
  renewalFrequenciesDetailsError: [],
  renewalFrequenciesDetailsLoading: false,

  addRenewalFrequenciesSuccess: [],
  addRenewalFrequenciesError: [],
  addRenewalFrequenciesLoading: false,

  updateRenewalFrequenciesSuccess: [],
  updateRenewalFrequenciesError: [],
  updateRenewalFrequenciesLoading: false,

  deleteRenewalFrequenciesSuccess: [],
  deleteRenewalFrequenciesError: [],
  deleteRenewalFrequenciesLoading: false,

  unitFrequenciesList: [],
  unitFrequenciesListError: [],
  unitFrequenciesListLoading: false,

  unitFrequenciesDetails: [],
  unitFrequenciesDetailsError: [],
  unitFrequenciesDetailsLoading: false,

  addUnitFrequenciesSuccess: [],
  addUnitFrequenciesError: [],
  addUnitFrequenciesLoading: false,

  updateUnitFrequenciesSuccess: [],
  updateUnitFrequenciesError: [],
  updateUnitFrequenciesLoading: false,

  deleteUnitFrequenciesSuccess: [],
  deleteUnitFrequenciesError: [],
  deleteUnitFrequenciesLoading: false,

  masterTimeFrameList: [],
  masterTimeFrameListError: [],
  masterTimeFrameListLoading: false,

  masterTimeFrameDetails: [],
  masterTimeFrameDetailsError: [],
  masterTimeFrameDetailsLoading: false,

  addMasterTimeFrameSuccess: [],
  addMasterTimeFrameError: [],
  addMasterTimeFrameLoading: false,

  updateMasterTimeFrameSuccess: [],
  updateMasterTimeFrameError: [],
  updateMasterTimeFrameLoading: false,

  deleteMasterTimeFrameSuccess: [],
  deleteMasterTimeFrameError: [],
  deleteMasterTimeFrameLoading: false,

  localSettingsMasterConfigList: [],
  localSettingsMasterConfigListError: [],
  localSettingsMasterConfigListLoading: false,

  configItemsCompanyEditableList: [],
  configItemsCompanyEditableListError: [],
  configItemsCompanyEditableListLoading: false,

  updateLocalSettingsMasterConfigToggleSuccess: [],
  updateLocalSettingsMasterConfigToggleError: [],
  updateLocalSettingsMasterConfigToggleLoading: false,

  localSettingsMasterConfigUserList: [],
  localSettingsMasterConfigUserListError: [],
  localSettingsMasterConfigUserListLoading: false,

  updateLocalSettingsMasterConfigUserSuccess: [],
  updateLocalSettingsMasterConfigUserError: [],
  updateLocalSettingsMasterConfigUserLoading: false,
};

export default function GeneralSettings(state = initialState, action) {
  switch (action.type) {
    // Get Vat Period List
    case GET_VAT_PERIOD_LIST:
      return {
        ...state,
        vatPeriodListLoading: true,
      };
    case GET_VAT_PERIOD_LIST_SUCCESS:
      return {
        ...state,
        vatPeriodList: action.payload,
        vatPeriodListLoading: false,
      };
    case GET_VAT_PERIOD_LIST_FAILURE:
      return {
        ...state,
        vatPeriodListError: action.payload,
        vatPeriodListLoading: false,
      };
    case GET_VAT_PERIOD_DETAILS:
      return {
        ...state,
        vatPeriodDetailsLoading: true,
      };
    case GET_VAT_PERIOD_DETAILS_SUCCESS:
      return {
        ...state,
        vatPeriodDetails: action.payload,
        vatPeriodDetailsLoading: false,
      };
    case GET_VAT_PERIOD_DETAILS_FAILURE:
      return {
        ...state,
        vatPeriodDetailsError: action.payload,
      };
    case ADD_VAT_PERIOD:
      return {
        ...state,
        addVatPeriodLoading: true,
      };
    case ADD_VAT_PERIOD_SUCCESS:
      return {
        ...state,
        addVatPeriodSuccess: action.payload,
        addVatPeriodLoading: false,
      };
    case ADD_VAT_PERIOD_FAILURE:
      return {
        ...state,
        addVatPeriodError: action.payload,
        addVatPeriodLoading: false,
      };
    case UPDATE_VAT_PERIOD:
      return {
        ...state,
        updateVatPeriodLoading: true,
      };
    case UPDATE_VAT_PERIOD_SUCCESS:
      return {
        ...state,
        updateVatPeriodSuccess: action.payload,
        updateVatPeriodLoading: false,
      };
    case UPDATE_VAT_PERIOD_FAILURE:
      return {
        ...state,
        updateVatPeriodError: action.payload,
        updateVatPeriodLoading: false,
      };
    case DELETE_VAT_PERIOD:
      return {
        ...state,
        deleteVatPeriodLoading: true,
      };
    case DELETE_VAT_PERIOD_SUCCESS:
      return {
        ...state,
        deleteVatPeriodSuccess: action.payload,
        deleteVatPeriodLoading: false,
      };
    case DELETE_VAT_PERIOD_FAILURE:
      return {
        ...state,
        deleteVatPeriodError: action.payload,
        deleteVatPeriodLoading: false,
      };
    // Get Renewal Frequencies List
    case GET_RENEWAL_FREQUENCIES_LIST:
      return { ...state, renewalFrequenciesListLoading: true };
    case GET_RENEWAL_FREQUENCIES_LIST_SUCCESS:
      return {
        ...state,
        renewalFrequenciesList: action.payload,
        renewalFrequenciesListLoading: false,
      };
    case GET_RENEWAL_FREQUENCIES_LIST_FAILURE:
      return {
        ...state,
        renewalFrequenciesListError: action.payload,
        renewalFrequenciesListLoading: false,
      };
    case GET_RENEWAL_FREQUENCIES_DETAILS:
      return { ...state, renewalFrequenciesDetailsLoading: true };
    case GET_RENEWAL_FREQUENCIES_DETAILS_SUCCESS:
      return {
        ...state,
        renewalFrequenciesDetails: action.payload,
        renewalFrequenciesDetailsLoading: false,
      };
    case GET_RENEWAL_FREQUENCIES_DETAILS_FAILURE:
      return {
        ...state,
        renewalFrequenciesDetailsError: action.payload,
        renewalFrequenciesDetailsLoading: false,
      };
    case ADD_RENEWAL_FREQUENCIES:
      return { ...state, addRenewalFrequenciesLoading: true };
    case ADD_RENEWAL_FREQUENCIES_SUCCESS:
      return {
        ...state,
        addRenewalFrequenciesSuccess: action.payload,
        addRenewalFrequenciesLoading: false,
      };
    case ADD_RENEWAL_FREQUENCIES_FAILURE:
      return {
        ...state,
        addRenewalFrequenciesError: action.payload,
        addRenewalFrequenciesLoading: false,
      };
    case UPDATE_RENEWAL_FREQUENCIES:
      return { ...state, updateRenewalFrequenciesLoading: true };
    case UPDATE_RENEWAL_FREQUENCIES_SUCCESS:
      return {
        ...state,
        updateRenewalFrequenciesSuccess: action.payload,
        updateRenewalFrequenciesLoading: false,
      };
    case UPDATE_RENEWAL_FREQUENCIES_FAILURE:
      return {
        ...state,
        updateRenewalFrequenciesError: action.payload,
        updateRenewalFrequenciesLoading: false,
      };
    case DELETE_RENEWAL_FREQUENCIES:
      return { ...state, deleteRenewalFrequenciesLoading: true };
    case DELETE_RENEWAL_FREQUENCIES_SUCCESS:
      return {
        ...state,
        deleteRenewalFrequenciesSuccess: action.payload,
        deleteRenewalFrequenciesLoading: false,
      };
    case DELETE_RENEWAL_FREQUENCIES_FAILURE:
      return {
        ...state,
        deleteRenewalFrequenciesError: action.payload,
        deleteRenewalFrequenciesLoading: false,
      };
    // Get Unit Frequencies List
    case GET_UNIT_FREQUENCIES_LIST:
      return { ...state, unitFrequenciesListLoading: true };
    case GET_UNIT_FREQUENCIES_LIST_SUCCESS:
      return {
        ...state,
        unitFrequenciesList: action.payload,
        unitFrequenciesListLoading: false,
      };
    case GET_UNIT_FREQUENCIES_LIST_FAILURE:
      return {
        ...state,
        unitFrequenciesListError: action.payload,
        unitFrequenciesListLoading: false,
      };
    case GET_UNIT_FREQUENCIES_DETAILS:
      return { ...state, unitFrequenciesDetailsLoading: true };
    case GET_UNIT_FREQUENCIES_DETAILS_SUCCESS:
      return {
        ...state,
        unitFrequenciesDetails: action.payload,
        unitFrequenciesDetailsLoading: false,
      };
    case GET_UNIT_FREQUENCIES_DETAILS_FAILURE:
      return {
        ...state,
        unitFrequenciesDetailsError: action.payload,
        unitFrequenciesDetailsLoading: false,
      };
    case ADD_UNIT_FREQUENCIES:
      return { ...state, addUnitFrequenciesLoading: true };
    case ADD_UNIT_FREQUENCIES_SUCCESS:
      return {
        ...state,
        addUnitFrequenciesSuccess: action.payload,
        addUnitFrequenciesLoading: false,
      };
    case ADD_UNIT_FREQUENCIES_FAILURE:
      return {
        ...state,
        addUnitFrequenciesError: action.payload,
        addUnitFrequenciesLoading: false,
      };
    case UPDATE_UNIT_FREQUENCIES:
      return { ...state, updateUnitFrequenciesLoading: true };
    case UPDATE_UNIT_FREQUENCIES_SUCCESS:
      return {
        ...state,
        updateUnitFrequenciesSuccess: action.payload,
        updateUnitFrequenciesLoading: false,
      };
    case UPDATE_UNIT_FREQUENCIES_FAILURE:
      return {
        ...state,
        updateUnitFrequenciesError: action.payload,
        updateUnitFrequenciesLoading: false,
      };
    case DELETE_UNIT_FREQUENCIES:
      return { ...state, deleteUnitFrequenciesLoading: true };
    case DELETE_UNIT_FREQUENCIES_SUCCESS:
      return {
        ...state,
        deleteUnitFrequenciesSuccess: action.payload,
        deleteUnitFrequenciesLoading: false,
      };
    case DELETE_UNIT_FREQUENCIES_FAILURE:
      return {
        ...state,
        deleteUnitFrequenciesError: action.payload,
        deleteUnitFrequenciesLoading: false,
      };
    // Get Master Time Frame List
    case GET_MASTER_TIME_FRAME_LIST:
      return { ...state, masterTimeFrameListLoading: true };
    case GET_MASTER_TIME_FRAME_LIST_SUCCESS:
      return {
        ...state,
        masterTimeFrameList: action.payload,
        masterTimeFrameListLoading: false,
      };
    case GET_MASTER_TIME_FRAME_LIST_FAILURE:
      return {
        ...state,
        masterTimeFrameListError: action.payload,
        masterTimeFrameListLoading: false,
      };
    case GET_MASTER_TIME_FRAME_DETAILS:
      return { ...state, masterTimeFrameDetailsLoading: true };
    case GET_MASTER_TIME_FRAME_DETAILS_SUCCESS:
      return {
        ...state,
        masterTimeFrameDetails: action.payload,
        masterTimeFrameDetailsLoading: false,
      };
    case GET_MASTER_TIME_FRAME_DETAILS_FAILURE:
      return {
        ...state,
        masterTimeFrameDetailsError: action.payload,
        masterTimeFrameDetailsLoading: false,
      };
    case ADD_MASTER_TIME_FRAME:
      return { ...state, addMasterTimeFrameLoading: true };
    case ADD_MASTER_TIME_FRAME_SUCCESS:
      return {
        ...state,
        addMasterTimeFrameSuccess: action.payload,
        addMasterTimeFrameLoading: false,
      };
    case ADD_MASTER_TIME_FRAME_FAILURE:
      return {
        ...state,
        addMasterTimeFrameError: action.payload,
        addMasterTimeFrameLoading: false,
      };
    case UPDATE_MASTER_TIME_FRAME:
      return { ...state, updateMasterTimeFrameLoading: true };
    case UPDATE_MASTER_TIME_FRAME_SUCCESS:
      return {
        ...state,
        updateMasterTimeFrameSuccess: action.payload,
        updateMasterTimeFrameLoading: false,
      };
    case UPDATE_MASTER_TIME_FRAME_FAILURE:
      return {
        ...state,
        updateMasterTimeFrameError: action.payload,
        updateMasterTimeFrameLoading: false,
      };
    case DELETE_MASTER_TIME_FRAME:
      return { ...state, deleteMasterTimeFrameLoading: true };
    case DELETE_MASTER_TIME_FRAME_SUCCESS:
      return {
        ...state,
        deleteMasterTimeFrameSuccess: action.payload,
        deleteMasterTimeFrameLoading: false,
      };
    case DELETE_MASTER_TIME_FRAME_FAILURE:
      return {
        ...state,
        deleteMasterTimeFrameError: action.payload,
        deleteMasterTimeFrameLoading: false,
      };
    // Get Local Settings Master Config List
    case GET_LOCAL_SETTINGS_MASTER_CONFIG_LIST:
      return { ...state, localSettingsMasterConfigListLoading: true };
    case GET_LOCAL_SETTINGS_MASTER_CONFIG_LIST_SUCCESS:
      return {
        ...state,
        localSettingsMasterConfigList: action.payload,
        localSettingsMasterConfigListLoading: false,
      };
    case GET_LOCAL_SETTINGS_MASTER_CONFIG_LIST_FAILURE:
      return {
        ...state,
        localSettingsMasterConfigListError: action.payload,
        localSettingsMasterConfigListLoading: false,
      };
    // Get Company Config Items (front-end editable) List
    case GET_CONFIG_ITEMS_COMPANY_EDITABLE_LIST:
      return { ...state, configItemsCompanyEditableListLoading: true };
    case GET_CONFIG_ITEMS_COMPANY_EDITABLE_LIST_SUCCESS:
      return {
        ...state,
        configItemsCompanyEditableList: action.payload,
        configItemsCompanyEditableListLoading: false,
      };
    case GET_CONFIG_ITEMS_COMPANY_EDITABLE_LIST_FAILURE:
      return {
        ...state,
        configItemsCompanyEditableListError: action.payload,
        configItemsCompanyEditableListLoading: false,
      };
    case UPDATE_LOCAL_SETTINGS_MASTER_CONFIG_TOGGLE:
      return { ...state, updateLocalSettingsMasterConfigToggleLoading: true };
    case UPDATE_LOCAL_SETTINGS_MASTER_CONFIG_TOGGLE_SUCCESS:
      return {
        ...state,
        updateLocalSettingsMasterConfigToggleSuccess: action.payload,
        updateLocalSettingsMasterConfigToggleLoading: false,
      };
    case UPDATE_LOCAL_SETTINGS_MASTER_CONFIG_TOGGLE_FAILURE:
      return {
        ...state,
        updateLocalSettingsMasterConfigToggleError: action.payload,
        updateLocalSettingsMasterConfigToggleLoading: false,
      };
    case GET_LOCAL_SETTINGS_MASTER_CONFIG_USER_LIST:
      return { ...state, localSettingsMasterConfigUserListLoading: true };
    case GET_LOCAL_SETTINGS_MASTER_CONFIG_USER_LIST_SUCCESS:
      return {
        ...state,
        localSettingsMasterConfigUserList: action.payload,
        localSettingsMasterConfigUserListLoading: false,
      };
    case GET_LOCAL_SETTINGS_MASTER_CONFIG_USER_LIST_FAILURE:
      return {
        ...state,
        localSettingsMasterConfigUserListError: action.payload,
        localSettingsMasterConfigUserListLoading: false,
      };
    case UPDATE_LOCAL_SETTINGS_MASTER_CONFIG_USER:
      return { ...state, updateLocalSettingsMasterConfigUserLoading: true };
    case UPDATE_LOCAL_SETTINGS_MASTER_CONFIG_USER_SUCCESS:
      return {
        ...state,
        updateLocalSettingsMasterConfigUserSuccess: action.payload,
        updateLocalSettingsMasterConfigUserLoading: false,
      };
    case UPDATE_LOCAL_SETTINGS_MASTER_CONFIG_USER_FAILURE:
      return {
        ...state,
        updateLocalSettingsMasterConfigUserError: action.payload,
        updateLocalSettingsMasterConfigUserLoading: false,
      };

    default:
      return state;
  }
}
